export function getProxyURL(url: string) {
  return `${process.env.REACT_APP_API}/proxy?url=${url}`;
}
